module.exports = __webpack_public_path__ + "static/media/00-eCSR-Ru-gy_4x.45c22c3a.png";